import RestResource from '../rest.service';

export default class PlotStageCommentsService extends RestResource {
  map(payload) {
    return {
      date: payload.date,
      body: payload.body,
      commentable_type: payload.commentableType,
      commentable_id: payload.commentableId,
    };
  }

  setCommentable(commentable) {
    this.parents = [];
    this.parents.push(commentable);
    return this;
  }

  constructor() {
    super('plot-stage/$0/comments');
  }
}
